module.exports = __webpack_public_path__ + "static/img/1.0faf6d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/1.png
// module id = WJXM
// module chunks = 0